import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Swipeable from 'react-swipeable';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/user';
import * as toursActions from '../../actions/tours';
import { connect } from 'react-redux';
import Translate from '../layout/Translate';
import TourSearchPreview from '../tours/SearchPreview';
import { Scrollbars } from 'react-custom-scrollbars';
import {monthsPeriod} from '../../api/monthsPeriod';
import moment from 'moment'



class MegaMenu extends Component {


	componentWillMount() {

		this.monthList = [];

		moment.locale(this.props.user.lang);
		for (let number = 1; number <= 12; number++) {

			this.monthList[number] = {id: number, title: moment(new Date('2017', number-1, '1')).format('MMMM'), months: number};

			//console.log(this.monthList[number]);
		}


		this.seasons = [{id: 1, title: <Translate slug="filter__winter" />, months: '12,1,2,3'}, {id: 2, title: <Translate slug="filter__spring" />, months: '3,4,5'}, {id: 3, title: <Translate slug="filter__summer" />, months: '6,7,8'}, {id: 4, title: <Translate slug="filter__autumn" />, months: '9,10,11'}];

	}


	componentDidUpdate() {

	}

	toggleMenu() {
		this.props.userActions.toggleMenu();
	}

	search() {

		if ( !!this.props.user.search && this.props.user.search.query) {
			this.props.userActions.textSearch(this.props.user.search.query);
		} else {
			this.props.userActions.clearSearchResults();
		}
	}

	clearSearch() {
		this.props.userActions.clearSearchResults();
	}

	changeQuery(e) {
		this.props.userActions.changeSearchQuery(e.target.value);
	}

	handleKeyPress(e) {
		if (e.key === 'Enter') {
			this.search();
		}
	}

	selectLandmark(landmark) {
		this.props.toursActions.selectLandmark(landmark.model);
		this.props.userActions.toggleMenu();
	}

	selectTour(tour) {
		this.props.toursActions.selectTour(tour);
	}
	selectPage(slug) {
		//console.log(slug);
		this.props.toursActions.selectPage(slug);
		this.props.userActions.toggleMenu();
	}

	goToToursList() {
		this.props.toursActions.selectActivity({});
		this.props.toursActions.selectSeason({});
		this.props.toursActions.selectDestination({});
		this.props.toursActions.selectType({});
		this.props.userActions.toggleMenu();
		this.props.toursActions.toursSearch({});

		this.props.toursActions.setMapConfig({
			listByMap: false,
			forceListBySearch: true
		});
	}
	selectDestination(destination) {
		this.props.toursActions.selectDestination(destination);
		this.props.toursActions.toursSearch({d: destination.id});
		this.props.userActions.toggleMenu();

		this.props.toursActions.setMapConfig({
			listByMap: false,
			forceListBySearch: true
		});
	}
	selectType(type) {
		this.props.toursActions.selectType(type);
		this.props.userActions.toggleMenu();

		this.props.toursActions.setMapConfig({
			listByMap: false,
			forceListBySearch: true
		});
	}
	selectSeason(season) {
		this.props.toursActions.selectSeason(season);
		this.props.toursActions.selectActivity({});
		this.props.toursActions.selectDestination({});
		this.props.toursActions.selectType({});
		this.props.userActions.toggleMenu();
		this.props.toursActions.toursSearch({m: season.months});

		this.props.toursActions.setMapConfig({
			listByMap: false,
			forceListBySearch: true
		});
	}

	selectActivity(activity) {
		this.props.toursActions.selectActivity(activity);
		this.props.toursActions.selectSeason({});
		this.props.toursActions.selectDestination({});
		this.props.toursActions.selectType({});
		this.props.userActions.toggleMenu();
		this.props.toursActions.toursSearch({a: activity.id});

		this.props.toursActions.setMapConfig({
			listByMap: false,
			forceListBySearch: true
		});
	}
	toggleContacts() {
		this.props.userActions.toggleContacts();
	}
	toggleFeedback() {
		this.props.userActions.toggleFeedback();
	}
	selectContactsDirection() {
		this.props.userActions.toggleMenu();
	}
	toggleSubscribe() {
		this.props.userActions.toggleSubscribe();
	}

  toggleCookiesPolicy() {
		this.props.userActions.toggleCookiesPolicy();
	}

  render() {

	  let search = this.props.user.search;
	  let {destinations, activities} = this.props;

	  let hasResults = true;
	  if (search && search.results) {
		  hasResults = false;
		  for (var index in search.results) {
				//console.log(search.results[index]);
			  if (search.results[index].length) {
				  hasResults = true;
			  }
		  }
	  }

    return (
		<section className={"mega-menu " + ((this.props.user.menuOpen)?'mega-menu_open':'')}>
			<div className="search">
				<div className="search__row">
					<div className="search__col search__col_width_full">
						<input className="search__input" value={(search && search.query)?search.query:""} onChange={this.changeQuery.bind(this)}  onKeyPress={this.handleKeyPress.bind(this)}  placeholder={(this.props.user && this.props.user.translations && this.props.user.translations.search__placeholder)?this.props.user.translations.search__placeholder:""} />
						{(search && search.query) &&
							<div className="search__padding">
								<div className="search__placeholder">{search.query}</div>

								<div className="search__clear" onClick={this.clearSearch.bind(this)}></div>
							</div>
						}
					</div>
					<div className="search__col search__col_width_fixed">
						{false &&
							<button className={"header__search header__search_button " + (this.props.user.search?'':'header__search_disabled')} onClick={this.search.bind(this)}></button>
						}
						<button
						className={"header__menu-button " + ((this.props.user.menuOpen)?'header__menu-button_active':'')} onClick={this.toggleMenu.bind(this)}><span className="header__menu-button_center"></span></button>
					</div>
				</div>


				{!(this.props.user.search && this.props.user.search.results) &&
					<div>
					<ul className="types types_menu">
						<li className="types__item_menu types__item_active"><Link to="/type/active" onClick={this.toggleMenu.bind(this)}></Link></li>
						<li className="types__item_menu types__item_discovery"><Link to="/type/discovery" onClick={this.toggleMenu.bind(this)}></Link></li>
						<li className="types__item_menu types__item_pure"><Link to="/type/pure" onClick={this.toggleMenu.bind(this)}></Link></li>
						<li className="types__item_menu types__item_cruise"><Link to="/type/cruise" onClick={this.toggleMenu.bind(this)}></Link></li>
						<li className="types__item_menu types__item_expedition"><Link to="/type/expedition" onClick={this.toggleMenu.bind(this)}></Link></li>
					</ul>

						<div className="mega-menu__lists">
							<div className="inline-list">
								<ul>
									{destinations.map((destination, i) =>
										<li key={i} className="inline-list__item">
											<Link to={"/destinations/" + destination.slug}  onClick={this.selectDestination.bind(this, destination)}>{destination.title}</Link>
										</li>
									)}
								</ul>
								<div className="inline-list__title"><Translate slug="menu__destinations" /></div>
							</div>

							<div className="inline-list">
								<ul>
									{activities.map((activity, i) =>
										<li key={i} className="inline-list__item">
											<Link to="/tours" query={{activity: activity.id}}  onClick={this.selectActivity.bind(this, activity)}>{activity.title}</Link>
										</li>
									)}
								</ul>
								<div className="inline-list__title"><Translate slug="menu__activities" /></div>
							</div>

							<div className="inline-list">
								<ul>
									{this.monthList.map((season, i)=>
										<li className="inline-list__item">
											<Link to={"/tours"} query={{season: i}}  onClick={this.selectSeason.bind(this, season)}>
												{season.title}
											</Link>
										</li>
									)}
								</ul>
									<div className="inline-list__title"><Translate slug="menu__seasons" /></div>

							</div>
						</div>

					</div>

				}

				{!hasResults &&
					<div className="search__error">
						<Translate slug="search__error" />
					</div>
				}

				{this.props.user.search && this.props.user.search.results && hasResults &&
					<div>
				<Swipeable>
					<Scrollbars  className="search__results results" style={{height: 470}}>

						<div className="results__line">
							{false &&
							<div className="results__section">
								<div className="results__title"><Translate slug="menu__promo" /></div>
								<div className="results__items">
										<div className="results__item result-promo">
											<div className="result-promo__title">
												ПРЕВОЗМОГАЯ
												СОБСТВЕННЫЕ
												СИЛЫ
											</div>
											<div className="result-promo__text">
												Вершина полуострова Святой
												Нос расположена на высоте
												1878 м.
											</div>
										</div>
								</div>
							</div>
							}
							{search.results.destinations && !!search.results.destinations.length && search.results.destinations[0].model &&
								<div className="results__section">
									<div className="results__title"><Translate slug="menu__destination" /></div>
									<div className="results__items">
										<Link to={"/destinations/" + search.results.destinations[0].model.slug}>
											<div className="results__item result-destination" style={{backgroundImage: (search.results.destinations[0].model.coverImages.previews && search.results.destinations[0].model.coverImages.previews.original)?"url("+search.results.destinations[0].model.coverImages.previews.original+")":""}} onClick={this.selectDestination.bind(this, search.results.destinations[0].model)}>
												<div className={"result-destination__title "  + ((search.results.destinations[0].model.title.length>7)?'result-destination__title_long':'')}>
													{search.results.destinations[0].model.title}
													<div className="result-destination__text">
														<Translate slug="menu__all-tours" />
													</div>
												</div>
											</div>
										</Link>
									</div>
								</div>
							}
							{search.results.tours && !!search.results.tours.length &&
								<div className="results__section">
									<div className="results__title"><Translate slug="menu__tours"/> <span
										className="results__count">{search.results.tours.length}</span></div>
									<div className="results__items">
										{search.results.tours.map((tour, i)=>
											<TourSearchPreview
												key={i}
												tour={tour.model}
												lang={this.props.user.lang}
												toggleMenu={this.props.userActions.toggleMenu}
												selectTour={this.props.toursActions.selectTour}
												loadTour={this.props.toursActions.fetchPostsIfNeeded}
												menuOpen={this.props.user.menuOpen}
											/>
										)}
									</div>

								</div>
							}
						</div>
					</Scrollbars>
				</Swipeable>


					{search.results.landmarks && !!search.results.landmarks.length &&
						<Scrollbars className="search__results results" style={{height: 212}}>
							<div className="results__line">
								<div className="results__section">
									<div className="results__title"><Translate slug="menu__landmarks"/> <span
										className="results__count">{search.results.landmarks.length}</span></div>
									<div className="results__items">
										{search.results.landmarks.map((landmark, i)=>
											<div className="results__item  results__landmarks" key={i}>
												<div className="search__landmark">
													<h4 className="landmark__title"><Link onClick={this.selectLandmark.bind(this, landmark)} to={"/info/landmarks/" + landmark.model.slug}>{landmark.model.title}</Link></h4>
													<Link className="landmark__text" onClick={this.selectLandmark.bind(this, landmark)} to={"/landmark/" + landmark.model.slug}>
														{landmark.model.content}
													</Link>
												</div>
											</div>
										)}
									</div>
								</div>

							</div>
						</Scrollbars>
					}


					{search.results.pages && !!search.results.pages.length &&
						<div className="search__results results results_list">
							<div className="results__line">
								<div className="results__section">
									<div className="results__title"><Translate slug="menu__other"/> <span
										className="results__count">{search.results.pages.length}</span></div>

									{search.results.pages.map((page, i)=>
										<div>
											<Link to={"/" + page.model.slug} onClick={this.toggleMenu.bind(this)} className="results__link">{page.model.title}</Link>
										</div>
									)}

								</div>

							</div>
						</div>
					}
				</div>
			}



				<div className="mega-menu__footer">
					<ul className="mega-menu__list">
						<li className="mega-menu__item mega-menu__item_count">
							<Link to="/tours" onClick={this.goToToursList.bind(this)}>
								<div className="mega-menu__count">
									70
								</div>
								<Translate slug="menu__tours__link" />
							</Link>
						</li>
						{false &&
							<li className="mega-menu__item mega-menu__item_count">
								<a href="#" onClick={this.toggleMenu.bind(this)}>
									<div className="mega-menu__count mega-menu__count_archive">
										64
									</div>
									<div className="mega-menu__count_text">
										<Translate slug="menu__archive__link" />
									</div>
								</a>
							</li>
						}
						<li className="mega-menu__item">
							<div className="mega-menu__count_text">
								<Link to="/about" onClick={this.toggleMenu.bind(this)}><Translate slug="menu__about" /></Link>
							</div>
						</li>
						<li className="mega-menu__item">
							<div className="mega-menu__count_text">
								<Link to="/reviews" onClick={this.toggleMenu.bind(this)}><Translate slug="menu__reviews" /></Link>
							</div>
						</li>
						<li className="mega-menu__item">
							<div className="mega-menu__count_text" onClick={this.toggleSubscribe.bind(this)}>
								<Translate slug="menu__subscribe" />
							</div>
						</li>
						<li className="mega-menu__item">
							<div className="mega-menu__count_text">
								<Link to="/custom-tour" onClick={this.toggleMenu.bind(this)}><Translate slug="menu__custom" /></Link>
							</div>
						</li>
					</ul>
					<ul className="mega-menu__contacts">
						<li className="mega-menu__contact">
							<Translate slug="menu__sp__phone" /><br/>
							<Translate slug="menu__sp" />
						</li>
						<li className="mega-menu__contact">
							<Translate slug="menu__irkutsk__phone" /><br/>
							<Translate slug="menu__irkutsk" />
						</li>
						<li className="mega-menu__contact" onClick={this.toggleFeedback.bind(this)}>
							<span className="mega-menu__mail"><Translate slug="menu__send" /></span>
						</li>
						<li className="mega-menu__contact"  onClick={this.toggleContacts.bind(this)}>
							<span className="mega-menu__office"><Translate slug="menu__offices" /></span>
						</li>
						<li className="mega-menu__contact mega-menu__contact_float_right">

							<a href="http://facebook.com/baikalnature" target="_blank" rel="nofollow" className="mega-menu__facebook"></a>
							<a href="https://www.youtube.com/BaikalNature" target="_blank" rel="nofollow" className="mega-menu__youtube"></a>
						</li>
					</ul>


					<ul className="mega-menu__list mega-menu__list_grey">
						<li className="mega-menu__item mega-menu__item_grey">
							<Link to="/conditions" onClick={this.selectPage.bind(this, 'conditions')}><Translate slug="menu__terms" /></Link>
						</li>
						<li className="mega-menu__item mega-menu__item_grey">
							<Link to="/privacy" onClick={this.selectPage.bind(this, 'privacy')}><Translate slug="menu__privacy" /></Link>
						</li>
						<li className="mega-menu__item mega-menu__item_grey">
							<Link to="/payment" onClick={this.selectPage.bind(this, 'payment')}><Translate slug="menu__payment" /></Link>
						</li>
					</ul>
					<div className="mega-menu__comment"><Translate slug="menu__copyright" /></div>
					<div className="mega-menu__comment"><Translate slug="main__registration" /></div>
				</div>
			</div>


			<div className={"popup " + (this.props.user.contactsOpen?'popup_active':'')}>
				<div className="popup__window popup__window_contacts contacts">
					<div className="popup__close" onClick={this.toggleContacts.bind(this)}></div>
					<div className="contacts__block">
						<div className="popup__title"><Translate slug="contacts__irkutsk__title" /></div>
						<p className="contacts__text"><Translate slug="contacts__irkutsk__schedule" /></p>
						<p className="contacts__text"><Translate slug="contacts__irkutsk__address" /></p>
						<Link to="/contacts" onClick={this.selectContactsDirection.bind(this)} className="contacts__direction"><Translate slug="contacts__get-direction" /></Link>
						<p className="contacts__text"><Translate slug="contacts__irkutsk__phone" /></p>
					</div>
					<div className="contacts__block">
						<div className="popup__title"><Translate slug="contacts__sp__title" /></div>
						<p className="contacts__text"><Translate slug="contacts__sp__schedule" /></p>
						<p className="contacts__text"><Translate slug="contacts__sp__address" /></p>
						<Link to="/contacts" onClick={this.selectContactsDirection.bind(this)} className="contacts__direction"><Translate slug="contacts__get-direction" /></Link>
						<p className="contacts__text"><Translate slug="contacts__sp__phone" /></p>
					</div>

				</div>
			</div>



		</section>
    );
  }
}



function mapStateToProps(state) {
	return {
		user : state.user,
		destinations : state.tours.destinations,
		activities : state.tours.activities,
		toursCount: state.tours.toursCount,
		filter: state.tours.mapFilterParams
	};
}

function mapDispatchToProps(dispatch) {
	return {
		toursActions: bindActionCreators(toursActions, dispatch),
		userActions: bindActionCreators(userActions, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(MegaMenu);



// WEBPACK FOOTER //
// ./src/common/components/layout/MegaMenu.js